module.exports = "<table datatable [dtOptions]=\"dtOptions\" [dtTrigger]=\"dtTrigger\" class=\"ui celled table\" style=\"width:100%\">\r\n</table>\r\n"